// import { authRole } from "shared/constants/AppConst";

export const getUserFromAuth0 = (user) => {
    if (user)
        return {
            id: 1,
            uid: user.sub,
            displayName: user.name,
            email: user.email,
            photoURL: user.picture,
            role: user.userRole,
        };
    return user;
};

export const getUserFromFirebase = (user) => {
    if (user)
        return {
            id: 1,
            uid: user.uid,
            displayName: user.displayName ? user.displayName : "Jyoti",
            email: user.email,
            photoURL: user.photoURL,
            role: user.userRole,
        };
    return user;
};
export const getUserFromAWS = (user) => {
    if (user)
        return {
            id: 1,
            uid: user.username,
            displayName: user.attributes.name
                ? user.attributes.name
                : "Admin User",
            email: user.attributes.email,
            photoURL: user.photoURL,
            role: user.userRole,
        };
    return user;
};

export const getUserFromJwtAuth = (user) => {
    if (user) {
        const userFullName = `${user.firstName} ${
            user.lastName !== null ? user.lastName : ""
        }`;
        return {
            id: 1,
            uid: user.userCode,
            displayName: userFullName,
            email: user.emailId,
            mobileNo: user.mobileNo,
            photoURL: user.avatar,
            role: user.userRole,
            location: user.location,
            department: user.deptMgr,
            roles: user.roleList,
        };
    }
    return user;
};
